/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_New_Lot_Code_PlaceholderInputs */

const vi_lot_items_new_lot_code_placeholder = /** @type {(inputs: Lot_Items_New_Lot_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: PL-LOT-ABC123`)
};

/**

* @param {Lot_Items_New_Lot_Code_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_new_lot_code_placeholder = /** @type {((inputs?: Lot_Items_New_Lot_Code_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_New_Lot_Code_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_new_lot_code_placeholder(inputs)
});